export default [
  'Пароль состоит минимум из 10 символов',
  'Буквы - только латинские',
  'Минимум одна заглавная буква',
  'Минимум одна десятичная цифра (от 0 до 9)',
  'Минимум один специальный символ: \r\n ` ~ ! @ # $ % ^ & * ( ) _ - + = { } [ ] \\ | : ; « » \' < > , . ? /',
];
